module.exports = __webpack_public_path__ + "media/images/upload_video-07d617bd.png";